export default __webpack_public_path__ + "static/media/admin-2.f76a2f5b.png";